<template>
  <div class="live-box">
    <div class="row">
      <div class="col-xs-12">
        <div class="live-box">
          <img class="cover" :src="'//thumbnail-large.micoworld.net/' + profile.cover" :data-cover="profile.cover" onerror="this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')" alt="">
          <div class="end" v-if="isEnd">
            <img class="avatar" :src="'//thumbnail-small.micoworld.net/' + profile.avatar" :data-cover="profile.avatar" onerror="this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')" />
            <div class="nickname">{{ profile.nickname }}</div>
            <p class="tip">This live has ended</p>
          </div>
          <div class="video-box" v-else>
            <flv v-if="flvSupported" :profile="profile" @end="endHandle" />
            <video-js v-else :profile="profile" @end="endHandle"></video-js>
            <div class="profile">
              <img :src="'//thumbnail-small.micoworld.net/' + profile.avatar" :data-cover="profile.avatar" onerror="this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')" alt="" class="avatar">
              <div class="name_id">
                <div class="nickname">{{ profile.nickname }}</div>
                <div class="id">{{ 'Mico ID: ' + profile.mico_id }}</div>
              </div>
            </div>

            <div class="chat_share">
              <div class="chat" @click="chatHandle">Invites you to chat</div>
              <img class="share" @click="chatHandle" src="//image.micoworld.net/8fc22411aad96f092587745b52669def" />
            </div>

            <div class="bubble-box download">
              <canvas id="canvas-bubble" width="36" height="300"></canvas>
              <div class="like-box" @click="giftHandle">
                <img class="live-lucybag" src="//image.micoworld.net/dd62cba35e3027a83c95f5bbea2c07c8" alt="">
              </div>
            </div>

            <p style="display:none">
              <img id="img1" src="/img/share/like1.png" alt="">
              <img id="img2" src="/img/share/like2.png" alt="">
              <img id="img3" src="/img/share/like3.png" alt="">
              <img id="img4" src="/img/share/like4.png" alt="">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import flvjs from 'flvjs'
  import Flv from './Flv'
  import VideoJs from './VideoJs'
  export default {
    components: { Flv, VideoJs },
    data() {
      const isAndroid = /android/i.test(window.navigator.userAgent)
      const isIos = /ios|iphone|ipod|ipad/i.test(window.navigator.userAgent)
      return {
        profile: window._profile,
        isEnd: !window._profile.is_live,
        flvSupported: flvjs.isSupported(),
        timer: 0,
        isAndroid,
        isIos,
        isPc: !isAndroid && !isIos
      }
    },
    computed: {
      chatLink() {
        return 'https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}'
//        return 'https://mico.onelink.me/Cndr/1do7vzsh'
//        if (this.isAndroid) {
//          return `https://u9b85.app.goo.gl?link=http%3A%2F%2Fwww.micoworld.net%2F&al=micoweb%3A%2F%2Fcom.mico%2Flive%2Fpub%3Fuid%3D${this.profile.uid}&apn=com.mico&afl=https%3A%2F%2Fapp.appsflyer.com%2Fcom.mico%3Fpid%3DShareLive`
//        } else if (this.isIos) {
//          return 'https://mico.onelink.me/O5Dq?pid=ShareLive&af_dp=micoweb%3A%2F%2Fcom.mico%2Fpub%2Fshare%2Flive%3Fuid%3D'+this.profile.uid+'%26roomid%3D'+this.profile.room_id+'&af_web_dp=http%3A%2F%2Fwww.micoworld.net%2F';
//        } else {
//          return 'https://www.micoworld.net'
//        }
      },
      giftLink() {
        return 'https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}'
//        return 'https://mico.onelink.me/Cndr/1do7vzsh'
//        return 'https://web-app.micoworld.net/web/pay.html'
      }
    },
    mounted() {
      this.bubble()
    },
    methods: {
      bubble() {
        if (!this.isEnd) {
          const jumpBubble = new JumpBubble({
            elCanvas : document.getElementById("canvas-bubble"),
            config : {
              alpha : 0.8,
              width : 30
            },
            callback : function(a,b,c){}
          })
          this.timer = setInterval(function(){
            if (Math.random() > 0.8) {
              var idName = "img" + Math.ceil(Math.random() * 4);
              jumpBubble.create({
                elImg: document.getElementById(idName)
              });
            }
          },200);
        }
      },
      endHandle() {
        this.isEnd = true
        clearInterval(this.timer)
      },
      chatHandle() {
        if (this.isIos) {
          const openUrl = 'micoweb://com.mico/pub/share/live?uid=' + this.profile.uid + '&roomid=' + this.profile.room_id;
          const iframe = document.createElement('iframe');
          const body = document.body;
          iframe.style.cssText='position:absolute;width:1px;height:1px;';
          iframe.src = openUrl;
          body.appendChild(iframe);
          this.timer = setTimeout(() => {
            window.location.href = this.chatLink;
          }, 500);
        } else {
          window.location.href = this.chatLink
        }
      },
      giftHandle() {
        window.location.href = this.giftLink
      }
    }
  }
</script>
<style lang="less">
@import "../css/live-box.less";
</style>
